var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cards__list" },
    [
      _vm._l(_vm.recipesList, function(recipe) {
        return _c("div", { key: recipe.name, staticClass: "card" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: recipe.data.image, alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("h3", [_vm._v(_vm._s(recipe.name))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(recipe.data.calories) +
                  " " +
                  _vm._s(_vm.$t("profile.home.recipeStats")) +
                  " / " +
                  _vm._s(recipe.data.time) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card__action",
                on: {
                  click: function() {
                    return _vm.selectRecipe(recipe)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("profile.home.viewRecipe")) +
                    "\n      "
                )
              ]
            )
          ])
        ])
      }),
      _vm._v(" "),
      _c("modal-component", {
        attrs: { modal: _vm.modal, recipe: _vm.viewRecipe },
        on: {
          close: _vm.closeRecipeView,
          changeModal: function($event) {
            _vm.modal = $event
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }